<div class="d-flex justify-content-between">
  <h2 mat-dialog-title class="bg-white">
      <i class="fa-light fa-square-poll-horizontal pe-2"></i> {{'poll_creation.title' | translate}}
  </h2>
  <mat-dialog-actions>
    <button type="button" class="btn p-0 border-0 fs-4 text-secondary" data-cy="close-creation-dialog" (click)="onClose()"><i
        class="fa-regular fa-xmark"></i></button>
  </mat-dialog-actions>
</div>

<mat-dialog-content class="dialog-content-pad-15 py-1 px-0">
  <mat-stepper [linear]="false" #stepper [orientation]="(stepperOrientation | async)!" (selectionChange)="onChange($event)">
    <ng-template matStepperIcon="edit">
      <i class="fa-solid fa-check"></i>
    </ng-template>
      
      @if(showIntro){
          <mat-step>
              <ng-template matStepLabel>Intro</ng-template>
              <ng-template matStepContent>
                  <div class="row step-content step-content py-3 px-4 gx-4">
                      <div class="col-md-6 form text-secondary kudos-intro">
                          <h3 class="pt-3 pb-2">{{'poll_creation.intro_title' | translate}}</h3>
                          <p class="pb-2">{{'poll_creation.intro_desc1' | translate}}<strong> {{'poll_creation.intro_desc1.1' | translate}}</strong> {{'poll_creation.intro_desc1.2' | translate}}</p>
                          <p class="pb-2">{{'poll_creation.intro_desc2' | translate}}</p>
                          <ul>
                              <li><strong>{{'poll_creation.intro_desc3' | translate}}</strong> {{'poll_creation.intro_desc3.1' | translate}}</li>
                              <li><strong>{{'poll_creation.intro_desc4' | translate}}</strong> {{'poll_creation.intro_desc4.1' | translate}}</li>
                              <li><strong>{{'poll_creation.intro_desc5' | translate}}</strong> {{'poll_creation.intro_desc5.1' | translate}}</li>
                          </ul>
                          <p class="py-2">{{'poll_creation.intro_ready' | translate}}</p>
                      </div>
                      @if((stepperOrientation | async)! === 'horizontal'){
                          <div class="col-md-6">
                              <div class="d-flex justify-content-center align-items-center">
                                  <img src="/assets/images/add_comment/talking-people.svg" width="300" class="pt-md-5">
                              </div>
                          </div>
                      }
                  </div>

                  <div class="step-navigation">
                      <div class="pb-2">
                          <label>
                              <input type="checkbox" [formControl]="dontShowAgainCtrl" [checked]="dontShowAgainCtrl.value"> {{'poll_creation.dont_show_again' | translate}}
                          </label>
                      </div>
                      <div>
                          <button ngClass="btn btn-primary" mat-button matStepperNext data-cy="continueToCustom">{{'poll_creation.continue' | translate}}<i class="fa-solid fa-caret-right ps-1"></i></button>
                      </div>
                  </div>
              </ng-template>
          </mat-step>
      }

<!-- Step 1 : Choose -->
@if(pollsTemplates.length > 1){
  <mat-step [stepControl]="chooseFormGroup" errorMessage="Question is required.">
    <ng-template matStepLabel>{{'poll_creation.choose' | translate}}</ng-template>
    <ng-template matStepContent>
      <form [formGroup]="chooseFormGroup">
        <div class="row step-content mt-2 py-3 px-4 gx-4">
          <div class="col-md-6 form pb-0">
            <p class="form-stepper-label">{{'poll_creation.choose_desc' | translate}}</p>
            <div class="pt-2 template-question-container">
              @for (template of pollsTemplates; track $index) {
              <button class="btn template-question d-flex"
                [ngClass]="template.label === poll?.label ? 'selected-template': ''" (click)="select(template)">
                <div>
                  <i class="fa-regular fa-square pe-2"></i>
                  <i class="fa-regular fa-square-check pe-2"></i>
                </div>
                <div>
                  {{template.label}}
                </div>
              </button>
              }
            </div>
            <div class="create-question-container pt-3">
              <button class="create-question-item" (click)="select(null, stepper)">
                <i class="fa-solid fa-pencil pe-1"></i> {{'poll_creation.create' | translate}}
              </button>
            </div>
          </div>
          @if((stepperOrientation | async)! === 'horizontal'){
          <div class="col-md-6 preview position-relative">
            <poll-preview [previewType]="previewType" 
                              [poll]="pollForPreview"
                              [author]="authorName" 
                              [options]="options"
                              [selectedTeams]="selectedTeams"
                              [allowComments]="poll._allowComments"
                              state="choose"></poll-preview>

            <div class="form-step-description position-absolute">
              <div class="alert alert-success mb-0" role="alert">
                <i class="far fa-info-circle"></i> {{'poll_creation.choose_desc2' | translate}}
              </div>
            </div>
          </div>
          }
        </div>
        <div class="step-navigation">
          <button class="btn btn-primary" data-cy="continueToCustomize" mat-button matStepperNext
            [disabled]="chooseFormGroup.invalid">{{'poll_creation.continue' | translate}}<i
              class="fa-solid fa-caret-right ps-1"></i></button>
        </div>
      </form>
    </ng-template>
  </mat-step>
}
    

<!-- Step 2 : Cutomize -->
    <mat-step label="Customize" [stepControl]="customizeFormGroup" errorMessage="Question is required.">
      <ng-template matStepLabel>{{'poll_creation.customize' | translate}}</ng-template>
      <ng-template matStepContent>
        <form [formGroup]="customizeFormGroup">
          <div class="row step-content step-content py-3 px-4 gx-4">
            <div class="col-md-6 form">
              <div class="form-group">
                <label class="form-label form-stepper-label" for="questionLabel">{{'poll_creation.customize_desc' |
                  translate}}</label>
                <textarea class="form-control pt-2" id="questionLabel" formControlName="labelCtrl"
                  [placeholder]="'poll_creation.type' | translate" rows="3" required></textarea>
                @if (labelCtrlCustomize.invalid && (labelCtrlCustomize.dirty || labelCtrlCustomize.touched)) {
                <p class="form-text text-danger">{{'poll_creation.customize_label_error' | translate}}</p>
                }
              </div>
              <div class="pt-4 row">
                <label class="col-sm-7 col-form-label form-stepper-label"
                        for="toggleDisplayAuthor">{{'poll_creation.customize_show_author' | translate}}</label>
                <div class="col-sm-5 pt-3 d-flex">
                  <div class="indicator">
                    @if(!poll?._displayAuthor){ <span class="pe-2">{{'No' | translate}}</span> }
                  </div>
                  <tm-slide-toggle id="toggleDisplayAuthor" formControlName="toggleDisplayAuthorCtrl"
                                    (ngModelChange)="toggleDisplayAuthor()"></tm-slide-toggle>
                  <div class="indicator">
                    @if(poll?._displayAuthor){ <span class="ps-2"> {{'Yes' | translate}}</span> }
                  </div>
                </div>
              </div>
              <div class="pt-4 row">
                <label class="col-sm-7 col-form-label form-stepper-label"
                        for="toggleAllowComments">{{'poll_creation.customize_allow_comments' | translate}}</label>
                <div class="col-sm-5 pt-3 d-flex">
                  <div class="indicator">
                    @if(!poll?._allowComments){ <span class="pe-2">{{'No' | translate}}</span> }
                  </div>
                  <tm-slide-toggle id="toggleAllowComments" formControlName="toggleAllowCommentsCtrl"
                                    (ngModelChange)="toggleAllowComments()"></tm-slide-toggle>
                  <div class="indicator">
                    @if(poll?._allowComments){ <span class="ps-2"> {{'Yes' | translate}}</span> }
                  </div>
                </div>
              </div>
              <div class="pt-4 pb-2 row">
                <label class="col-sm-4 col-form-label form-stepper-label"
                  for="answerOptionsType">{{'poll_creation.customize_type' | translate}}</label>
                <div class="col-sm-8">
                  <select formControlName="typeCtrl" id="answerOptionsType" name="answerOptionsType" class="form-select">
                    @for(type of possibleAnswerOptionTypes; track type) {
                    <option [ngValue]="type.type">{{type.translateKey | translate}}</option>
                    }
                  </select>
                </div>

              </div>
              @if(poll?.answerOptions){
              <answer-choices [options]="poll.answerOptions"
                              (onOptionChange)="onAnswerOptionChange($event)"></answer-choices>
              }
            </div>

            @if((stepperOrientation | async)! === 'horizontal'){
            <div class="col-md-6 preview">
              <poll-preview [previewType]="previewType" 
                                [poll]="pollForPreview" 
                                [author]="authorName" 
                                [options]="options"
                                [selectedTeams]="selectedTeams"
                                [allowComments]="poll._allowComments"
                                state="customize"></poll-preview>
            </div>
            }
          </div>
          <div class="step-navigation">
            <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button> -->
            <button ngClass="btn btn-primary" data-cy="continueToTarget" mat-button matStepperNext
              [disabled]="customizeFormGroup.invalid || !areOptionsValid">{{'poll_creation.continue' | translate}}<i
                class="fa-solid fa-caret-right ps-1"></i></button>
          </div>
        </form>

      </ng-template>
    </mat-step>

<!-- Step 3 : Target -->
    <mat-step label="Target" [stepControl]="targetFormGroup" errorMessage="Recipients are required.">
      <ng-template matStepLabel>{{'poll_creation.target' | translate}}</ng-template>
      <ng-template matStepContent>
        <form [formGroup]="targetFormGroup">

          <div class="row step-content py-3 px-4 gx-4">
            <div class="col-md-6 form">
              <p class="form-stepper-label">{{'poll_creation.target_desc' | translate}}</p>
              <div>
                <multi-team-selector  [teams]="teams"
                                      (onTeamSelectionChanged)="uptadeTeams($event)"
                                      [context]="'questionCreaction'"></multi-team-selector>

              </div>
              @if(recipients){
              <div class="form-step-description">
                <p>{{'poll_creation.target_output_desc1' | translate}} {{recipients}}
                  {{'poll_creation.target_output_desc1b' | translate}}</p>
                <p>{{'poll_creation.target_output_desc2' | translate}}</p>
              </div>
              }
            </div>
            @if((stepperOrientation | async)! === 'horizontal'){
            <div class="col-md-6 preview">
              <poll-preview [previewType]="previewType" 
                                [poll]="pollForPreview"
                                [author]="authorName"
                                [options]="options"
                                [selectedTeams]="selectedTeams"
                                [allowComments]="poll._allowComments"
                                state="target"></poll-preview>
            </div>
            }
          </div>
          <div class="step-navigation">
            <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button>             -->
            <button ngClass="btn btn-primary" data-cy="continueToSchedule" mat-button matStepperNext
              [disabled]="targetFormGroup.invalid">{{'poll_creation.continue' | translate}}<i
                class="fa-solid fa-caret-right ps-1"></i></button>
          </div>
        </form>

      </ng-template>
    </mat-step>

<!-- Step 4 : Schedule -->
        <mat-step label="Schedule" [stepControl]="scheduleFormGroup" errorMessage="Scheduling options are required.">
          <form [formGroup]="scheduleFormGroup" class="schedule-form">
            <ng-template matStepLabel>{{'poll_creation.schedule' | translate}}</ng-template>
            <div class="row step-content py-3 px-4 gx-4">
                <div class="col-md-6 form">   
                  <!-- <p>Schedule your question : when and how long to display it</p> -->
                  <div class="form-group text-center pb-4">
                    <label class="form-label form-stepper-label" for="publicationDate">{{'poll_creation.schedule_date' | translate}}</label>
                    @if(poll){
                      <date-picker [date]="poll.scheduleOptions.publicationDate"
                                   (onDateChange)="updatePublicationDate($event)"></date-picker>
                    }
                  </div>
                  <div class="form-group text-center pb-4">
                    <label class="form-label form-stepper-label" for="displayDuration">{{'poll_creation.schedule_duration' | translate}}</label>
                    <div class="d-flex justify-content-center align-items-center">
                        <input id="displayDuration" type="number" name="displayDuration" min="1" max="30"
                               class="form-control me-2"
                               formControlName="displayDurationCtrl"> 
                        <span class="text-secondary">{{'poll_creation.schedule_duration_unit' | translate}}</span> 
                    </div>
                    @if ((displayDurationCtrl.invalid && (displayDurationCtrl.dirty || displayDurationCtrl.touched)) || (recurrenceCtrl.invalid && (recurrenceCtrl.dirty || recurrenceCtrl.touched))) {
                      <p class="form-text text-danger">{{recurrenceErrorMessage}}</p>
                    }
                  </div>
                  <div class="form-group text-center pb-4">
                    <label class="form-label form-stepper-label" for="recurrence">{{'poll_creation.schedule_recurrence' | translate}}</label>
                    <select formControlName="recurrenceCtrl" id="recurrence"
                            name="recurrence" class="form-select">
                            @for(option of recurrenceOptions; track option) {
                                <option [ngValue]="option">{{ 'poll_creation.recurrence.' + option | translate}}</option>
                            }
                    </select>
                  </div>
                  @if(options){
                    <div class="form-step-description">
                      <p>
                        @if(isToday(options.displayStartDate)){
                          {{'poll_creation.schedule_output_desc1_today' | translate}} {{options.displayEndDate | date: 'fullDate'}}.
                        }@else{
                          {{'poll_creation.schedule_output_desc1' | translate}} {{options.displayStartDate | date: 'fullDate'}} {{'poll_creation.schedule_output_to' | translate}} {{options.displayEndDate | date: 'fullDate'}}.
                        }
                      </p>
                      <p>{{'poll_creation.schedule_output_desc3' | translate}} {{options.resultPublicationDate | date: 'fullDate'}}.</p>
                      <div class="alert alert-success mt-3 mtb-0" role="alert">
                        <i class="far fa-info-circle pe-1"></i> {{'poll_creation.schedule_output_desc2' | translate}} {{options.reminderDate | date: 'fullDate'}} {{'poll_creation.schedule_output_desc2b' | translate}}
                      </div>
                    </div>
                  }
                </div>
                @if((stepperOrientation | async)! === 'horizontal'){
                  <div class="col-md-6 preview">
                    <poll-preview [previewType]="previewType"
                                      [poll]="pollForPreview"
                                      [author]="authorName" 
                                      [options]="options"
                                      [recurrence]="recurrence"
                                      [selectedTeams]="selectedTeams"
                                      [allowComments]="poll._allowComments"
                                      state="schedule"></poll-preview>                
                  </div>
                }
            </div>
            <div class="step-navigation">
              <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button>             -->
              <button ngClass="btn btn-primary" data-cy="continueToPublish" mat-button matStepperNext
                      [disabled]="scheduleFormGroup.invalid">{{'poll_creation.continue' | translate}}<i class="fa-solid fa-caret-right ps-1"></i></button>
            </div>
          </form>
        </mat-step>
<!-- Final Step : Review and Publish -->
    <mat-step>
      <ng-template matStepLabel>{{'poll_creation.publish' | translate}}</ng-template>
      <ng-template matStepContent>
        <div class="row step-content py-3 px-4 gx-4">
          <div class="col-md-6 form text-center">
            <p class="form-stepper-label">{{'poll_creation.publish_desc1' | translate}}</p>
            <p>{{'poll_creation.publish_desc2' | translate}}</p>
          </div>
          @if((stepperOrientation | async)! === 'horizontal'){
          <div class="col-md-6 preview">
            <poll-preview [previewType]="previewType"
                              [poll]="pollForPreview"
                              [author]="authorName"
                              [options]="options"
                              [selectedTeams]="selectedTeams"
                              [allowComments]="poll._allowComments"
                              state="publish"></poll-preview>
          </div>
          }
        </div>
        <div class="step-navigation">
          <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button>             -->
          <button class="btn btn-secondary px-sm-4 mx-2" data-cy="publishPoolSerial" mat-button
                  [disabled]="scheduleFormGroup.invalid || targetFormGroup.invalid || customizeFormGroup.invalid"
                  (click)="createPoll(true)">{{'poll_creation.publish_serial' | translate}}</button>
          <button class="btn btn-primary px-sm-4 mx-2" data-cy="publishPool" mat-button
                  [disabled]="scheduleFormGroup.invalid || targetFormGroup.invalid || customizeFormGroup.invalid"
                  (click)="createPoll(false)">{{'poll_creation.publish' | translate}}</button>
          
        </div>
      </ng-template>

    </mat-step>
  </mat-stepper>
</mat-dialog-content>